import {
  CREATE_DUPLICATE,
  UPDATE_DUPLICATE,
  GET_DUPLICATE,
  GET_ONE_DUPLICATE,
} from '../types'

const INITIAL_STATE = {
  addDuplicate: [],
  putDuplicate: [],
  allDuplicate: [],
  oneDuplicate: [],
}

const duplicateCheckReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CREATE_DUPLICATE:
      return {
        ...state,
        addDuplicate: payload.data,
      }
    case UPDATE_DUPLICATE:
      return {
        ...state,
        putDuplicate: payload.data,
      }
    case GET_DUPLICATE:
      return {
        ...state,
        allDuplicate: payload.data,
      }
    case GET_ONE_DUPLICATE:
      return {
        ...state,
        oneDuplicate: payload.data,
      }

    default:
      return state
  }
}

export default duplicateCheckReducer
